export class SubscriptionApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async getStatus() {
        return this.client.get('/api/account/subscription');
    }
    async getCatalogPrices() {
        return this.client.get('/api/account/subscription/catalog-prices');
    }
    async getBillingDetails() {
        return this.client.get('/api/account/subscription/billing-details');
    }
    async createCheckoutSession(product, options) {
        return this.client.post('/api/account/subscription/checkout', {
            product,
            ...(options?.returnTo ? { returnTo: options.returnTo } : {}),
        });
    }
    async createPortalSession() {
        return this.client.post('/api/account/subscription/portal', {});
    }
}
//# sourceMappingURL=subscription-api.js.map